// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2-pMy","footer":"ModalUpdate_footer__1Jq5w"};